<modal-layout-right modalTitle="Basket"
                    [scrollId]="'minibasket-scroll'"
                    [modalSubtitle]="(basket.qty === 1 ? '% item' : '% items') | translate : basket.qty">

    <div modalBody
         cy-minibasketView>

        @if (basket.qty) {
        <div>
            <basket-free-shipping class="block m-b-8"></basket-free-shipping>
            @for (item of basket.items | orderBy : ['data.added_at'] : ['desc']; track itemTrackFn($index, item); let
            last = $last; let first = $first) {
            <basket-view-item class="block p-b"
                              [class.m-t]="!first"
                              [class.b-b]="!last"
                              [item]="item"
                              cy-minibasketItem></basket-view-item>
            }
        </div>
        <icms-outlet [components]="content.bottomComponents"
                     [allow]="['upsell-product-carousel-layout']">
        </icms-outlet>
        }
        @if (!basket.qty) {
        <div cy-basketEmpty
             class="center p2 col-1"
             translate>
            Your basket is empty
        </div>
        <icms-outlet [components]="content.emptyComponents">
        </icms-outlet>
        }

    </div>

    @if (basket.qty) {
    <div modalFooter
         class="m-b-6">
        <basket-view-totals class="block m-t-5 m-t-9-s m-t-9-m"></basket-view-totals>

        <basket-view-submit class="block m-t"
                            [link]="'/basket'"></basket-view-submit>
        <basket-view-pay-with class="block m-t center"
                              [paymentMethods]="content.payment_method_icons"></basket-view-pay-with>
        <p *iCms="'footerNote' of content; skipEmpty: true"
           text
           class="p2 col-1 m-t center"></p>
    </div>
    }

</modal-layout-right>
